export class KeyValuePair<K, V> {

    constructor(public key: K, public value: V) {
    }
}
